/* Aruná — comportamiento del tema */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Barra de anuncios: rotación + cierre
     --------------------------------------------------------------- */
  function initAnnouncement(root) {
    var bar = root.querySelector('[data-announcement]');
    if (!bar) return;

    var key = 'aruna_ann_dismissed';
    var dismissible = bar.getAttribute('data-dismissible') === 'true';

    if (dismissible) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }

    var messages = bar.querySelectorAll('.announcement__message');
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 9000;

    if (messages.length > 1) {
      var index = 0;
      setInterval(function () {
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, interval);
    }

    var close = bar.querySelector('.announcement__close');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  }

  /* ---------------------------------------------------------------
     Menú móvil
     --------------------------------------------------------------- */
  function initHeader(root) {
    var toggle = root.querySelector('[data-menu-toggle]');
    var drawer = root.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------------------------------------------------------
     Acordeones
     --------------------------------------------------------------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var single = accordion.getAttribute('data-accordion') === 'single';

      accordion.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!panel) return;
          var isOpen = panel.classList.contains('is-open');

          if (single) {
            accordion.querySelectorAll('.accordion__panel.is-open').forEach(function (p) {
              p.classList.remove('is-open');
              var t = accordion.querySelector('[aria-controls="' + p.id + '"]');
              if (t) {
                t.setAttribute('aria-expanded', 'false');
                var i = t.querySelector('.accordion__icon');
                if (i) i.textContent = '+';
              }
            });
          }

          if (isOpen) {
            panel.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            panel.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }

          var icon = trigger.querySelector('.accordion__icon');
          if (icon) icon.textContent = panel.classList.contains('is-open') ? '–' : '+';
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Pestañas de FAQ
     --------------------------------------------------------------- */
  function initFaqTabs(root) {
    root.querySelectorAll('[data-faq-tabs]').forEach(function (wrapper) {
      var tabs = wrapper.querySelectorAll('[data-faq-tab]');
      var groups = wrapper.querySelectorAll('[data-faq-group]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-faq-tab');
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          groups.forEach(function (g) {
            g.classList.toggle('is-active', g.getAttribute('data-faq-group') === target);
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Galería de producto
     --------------------------------------------------------------- */
  function initGallery(root) {
    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      // El marcador puede estar en la propia imagen o en su contenedor.
      // Si no hay ninguno, se cae a la primera imagen del bloque principal,
      // para que un cambio de plantilla no deje las miniaturas muertas.
      var marcado = gallery.querySelector('[data-gallery-main]');
      var main = null;
      if (marcado) {
        main = marcado.tagName === 'IMG' ? marcado : marcado.querySelector('img');
      }
      if (!main) {
        var caja = gallery.querySelector('.product__gallery-main');
        main = caja ? caja.querySelector('img') : null;
      }
      if (!main) return;

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) {
            main.src = src;
            main.alt = alt;
            if (srcset) main.srcset = srcset;
          }
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Selector de cantidad
     --------------------------------------------------------------- */
  function initQuantity(root) {
    root.querySelectorAll('[data-quantity]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      if (!input) return;

      wrapper.querySelectorAll('[data-quantity-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-quantity-change'), 10);
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var value = parseInt(input.value, 10) || min;
          input.value = Math.max(min, value + delta);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Carrito: cambios de cantidad envían el formulario
     --------------------------------------------------------------- */
  function initCart(root) {
    var form = root.querySelector('[data-cart-form]');
    if (!form) return;

    form.querySelectorAll('[data-cart-quantity] input').forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });

    form.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-cart-remove');
        var input = form.querySelector('[data-line="' + line + '"] input');
        if (input) {
          input.value = 0;
          form.submit();
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     Variantes de producto
     --------------------------------------------------------------- */
  function initVariants(root) {
    root.querySelectorAll('[data-variant-selector]').forEach(function (selector) {
      var section = selector.closest('[data-product-section]');
      if (!section) return;

      var idInput = section.querySelector('[data-variant-id]');
      var priceEl = section.querySelector('[data-variant-price]');
      var compareEl = section.querySelector('[data-variant-compare]');
      var submit = section.querySelector('[data-add-button]');
      var data = section.querySelector('[data-variant-json]');
      if (!data) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      selector.addEventListener('change', function () {
        var selected = Array.prototype.map.call(
          section.querySelectorAll('[data-variant-selector] select, [data-variant-selector] input:checked'),
          function (el) { return el.value; }
        );

        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });

        if (!match) return;

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = match.price_formatted;
        if (compareEl) {
          compareEl.innerHTML = match.compare_at_price_formatted || '';
          compareEl.hidden = !match.compare_at_price_formatted;
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? submit.getAttribute('data-label-available')
            : submit.getAttribute('data-label-sold-out');
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     Quiz de piel
     --------------------------------------------------------------- */
  function initQuiz(root) {
    root.querySelectorAll('[data-quiz]').forEach(function (quiz) {
      var stages = quiz.querySelectorAll('[data-quiz-stage]');
      var questions = quiz.querySelectorAll('[data-quiz-question]');
      var results = quiz.querySelectorAll('[data-quiz-result]');
      var total = questions.length;
      var answers = {};
      var step = 0;

      function show(name) {
        stages.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-quiz-stage') === name);
        });
      }

      function showQuestion(i) {
        step = i;
        questions.forEach(function (q, idx) {
          q.hidden = idx !== i;
        });
        var fill = quiz.querySelector('[data-quiz-progress]');
        var label = quiz.querySelector('[data-quiz-step-label]');
        var percent = Math.round(((i + 1) / total) * 100);
        if (fill) {
          fill.style.width = percent + '%';
          var bar = fill.closest('[role="progressbar"]');
          if (bar) bar.setAttribute('aria-valuenow', percent);
        }
        if (label) {
          label.textContent = label.getAttribute('data-template')
            .replace('[current]', i + 1)
            .replace('[total]', total);
        }
        show('questions');
      }

      function computeResult() {
        var best = null;
        var bestScore = -1;

        results.forEach(function (result) {
          var rules = (result.getAttribute('data-match') || '').split('|').filter(Boolean);
          var score = 0;
          rules.forEach(function (rule) {
            var parts = rule.split(':');
            if (parts.length === 2 && answers[parts[0]] === parts[1]) score++;
          });
          if (score > bestScore) {
            bestScore = score;
            best = result;
          }
        });

        results.forEach(function (r) { r.hidden = r !== best; });
        show('result');
      }

      quiz.querySelectorAll('[data-quiz-start]').forEach(function (btn) {
        btn.addEventListener('click', function () { showQuestion(0); });
      });

      quiz.querySelectorAll('[data-quiz-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (step === 0) { show('intro'); return; }
          showQuestion(step - 1);
        });
      });

      quiz.querySelectorAll('[data-quiz-retake]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers = {};
          quiz.querySelectorAll('input[type="radio"]').forEach(function (i) { i.checked = false; });
          quiz.querySelectorAll('.quiz__option').forEach(function (o) { o.classList.remove('is-selected'); });
          show('intro');
        });
      });

      quiz.querySelectorAll('input[type="radio"][data-question]').forEach(function (input) {
        input.addEventListener('change', function () {
          answers[input.getAttribute('data-question')] = input.value;

          var group = input.closest('[data-quiz-question]');
          if (group) {
            group.querySelectorAll('.quiz__option').forEach(function (o) {
              o.classList.toggle('is-selected', o.contains(input));
            });
          }

          window.setTimeout(function () {
            if (step < total - 1) showQuestion(step + 1);
            else computeResult();
          }, 180);
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Fondos de video
     El src no va en el HTML: así el móvil nunca descarga el video de
     escritorio, ni descarga nada si se pidió usar la imagen.
     --------------------------------------------------------------- */
  function initBackgroundVideo(root) {
    // El video pesa megas. Si se pide durante la carga, compite con la imagen
    // del banner y retrasa el primer pintado. Se arranca cuando ya cargo todo.
    var arrancar = function () {
      montarVideosDeFondo(root);
    };

    if (document.readyState === 'complete') {
      arrancar();
    } else {
      window.addEventListener('load', function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(arrancar, { timeout: 1500 });
        } else {
          setTimeout(arrancar, 200);
        }
      });
    }
  }

  function montarVideosDeFondo(root) {
    root.querySelectorAll('[data-bg-video]').forEach(function (holder) {
      if (holder.dataset.ready === 'true') return;

      var isMobile = window.innerWidth < 750;
      var hideOnMobile = holder.getAttribute('data-hide-mobile') === 'true';

      // Si se pidio imagen en movil, en movil no hay video: ni el propio.
      // Un video de fondo son megas, y esa casilla existe para no gastarlos.
      if (isMobile && hideOnMobile) return;

      var src = isMobile
        ? holder.getAttribute('data-mobile') || holder.getAttribute('data-desktop')
        : holder.getAttribute('data-desktop');

      if (!src) return;

      holder.dataset.ready = 'true';

      var video = document.createElement('video');
      video.autoplay = true;
      video.muted = true;
      video.playsInline = true;
      video.loop = holder.getAttribute('data-loop') === 'true';
      video.preload = 'metadata';
      video.setAttribute('aria-hidden', 'true');

      var poster = isMobile
        ? holder.getAttribute('data-poster')
        : holder.getAttribute('data-poster-desktop');
      if (poster) video.poster = poster;

      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);

      video.addEventListener('loadeddata', function () {
        holder.classList.add('bg-media--playing');
      });

      holder.appendChild(video);

      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    });
  }

  /* ---------------------------------------------------------------
     Vista rápida
     Un solo modal para toda la tienda. Los datos del producto se piden
     a /products/{handle}.js al abrirlo, no en la carga de la página.
     --------------------------------------------------------------- */
  function initQuickView(root) {
    var modal = document.querySelector('[data-quickview-modal]');
    if (!modal) return;

    var q = function (sel) { return modal.querySelector(sel); };
    var etiqueta = function (n) { return modal.getAttribute('data-label-' + n) || ''; };

    var cuerpo = q('[data-quickview-body]');
    var cargando = q('[data-quickview-loading]');
    var img = q('[data-qv-image]');
    var titulo = q('[data-qv-title]');
    var tipo = q('[data-qv-type]');
    var precio = q('[data-qv-price]');
    var comparar = q('[data-qv-compare]');
    var desc = q('[data-qv-desc]');
    var opciones = q('[data-qv-options]');
    var cantidad = q('[data-qv-qty] input');
    var boton = q('[data-qv-add]');
    var mensaje = q('[data-qv-msg]');
    var enlace = q('[data-qv-link]');

    var producto = null;
    var variante = null;
    var abridor = null;

    // El formato de moneda viene de la tienda: ${{amount}}, {{amount}} €, etc.
    var formato = modal.getAttribute('data-money-format') || '${{amount}}';
    var dinero = function (centavos) {
      var n = (centavos / 100).toFixed(2);
      var partes = n.split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return formato.replace(/\{\{\s*amount[^}]*\}\}/, partes.join('.'));
    };

    var aviso = function (texto, tono) {
      if (!texto) { mensaje.hidden = true; return; }
      mensaje.textContent = texto;
      mensaje.className = 'qv__msg' + (tono ? ' qv__msg--' + tono : '');
      mensaje.hidden = false;
    };

    var pintarVariante = function () {
      if (!variante) return;
      precio.textContent = dinero(variante.price);
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        comparar.textContent = dinero(variante.compare_at_price);
        comparar.hidden = false;
      } else {
        comparar.hidden = true;
      }
      if (variante.featured_image && variante.featured_image.src) {
        img.src = variante.featured_image.src;
      }
      boton.disabled = !variante.available;
      boton.textContent = variante.available ? etiqueta('add') : etiqueta('soldout');
    };

    var elegirVariante = function () {
      var elegidas = Array.prototype.map.call(
        opciones.querySelectorAll('select'),
        function (s) { return s.value; }
      );
      var encontrada = producto.variants.filter(function (v) {
        return elegidas.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (encontrada) { variante = encontrada; pintarVariante(); }
    };

    var pintar = function (p) {
      producto = p;
      variante = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];

      titulo.textContent = p.title;
      enlace.href = p.url;

      if (p.type) { tipo.textContent = p.type; tipo.hidden = false; } else { tipo.hidden = true; }

      var imagen = (variante.featured_image && variante.featured_image.src) || p.featured_image;
      if (imagen) { img.src = imagen; img.alt = p.title; }

      var texto = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      if (texto) { desc.textContent = texto.slice(0, 180) + (texto.length > 180 ? '…' : ''); desc.hidden = false; }
      else { desc.hidden = true; }

      // Un producto sin variantes reales trae una sola, "Default Title".
      var conVariantes = p.variants.length > 1;
      opciones.innerHTML = '';
      if (conVariantes) {
        p.options.forEach(function (opcion, i) {
          var nombre = opcion.name || opcion;
          var valores = opcion.values || [];
          if (!valores.length) {
            valores = p.variants.map(function (v) { return v.options[i]; }).filter(function (v, k, a) { return a.indexOf(v) === k; });
          }
          var campo = document.createElement('label');
          campo.className = 'qv__option';
          campo.innerHTML = '<span>' + nombre + '</span>';
          var select = document.createElement('select');
          valores.forEach(function (val) {
            var op = document.createElement('option');
            op.value = val; op.textContent = val;
            if (variante.options[i] === val) op.selected = true;
            select.appendChild(op);
          });
          select.addEventListener('change', elegirVariante);
          campo.appendChild(select);
          opciones.appendChild(campo);
        });
        opciones.hidden = false;
      } else {
        opciones.hidden = true;
      }

      cantidad.value = 1;
      aviso('');
      pintarVariante();

      cargando.hidden = true;
      cuerpo.hidden = false;
    };

    var cerrar = function () {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (abridor) { abridor.focus(); abridor = null; }
    };

    var abrir = function (handle, disparador) {
      abridor = disparador || null;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      cuerpo.hidden = true;
      cargando.hidden = false;
      aviso('');

      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
        .then(pintar)
        .catch(function () {
          cargando.hidden = true;
          cuerpo.hidden = false;
          aviso(etiqueta('error'), 'error');
        });
    };

    root.querySelectorAll('[data-quickview]').forEach(function (btn) {
      if (btn.dataset.qvListo === '1') return;
      btn.dataset.qvListo = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir(btn.getAttribute('data-quickview'), btn);
      });
    });

    if (modal.dataset.qvListo === '1') return;
    modal.dataset.qvListo = '1';

    modal.querySelectorAll('[data-quickview-close]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrar();
    });

    q('[data-qv-minus]').addEventListener('click', function () {
      cantidad.value = Math.max(1, (parseInt(cantidad.value, 10) || 1) - 1);
    });
    q('[data-qv-plus]').addEventListener('click', function () {
      cantidad.value = (parseInt(cantidad.value, 10) || 1) + 1;
    });

    boton.addEventListener('click', function () {
      if (!variante || boton.disabled) return;
      var previo = boton.textContent;
      boton.disabled = true;
      boton.textContent = etiqueta('adding');
      aviso('');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variante.id, quantity: parseInt(cantidad.value, 10) || 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || 'error');
          boton.textContent = etiqueta('added');
          aviso('', '');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (carrito) {
          if (!carrito) return;
          document.querySelectorAll('.header__cart-count').forEach(function (c) {
            c.textContent = carrito.item_count;
          });
          setTimeout(function () {
            boton.textContent = previo;
            boton.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          boton.textContent = previo;
          boton.disabled = false;
          aviso(err.message || etiqueta('error'), 'error');
        });
    });
  }

  /* ---------------------------------------------------------------
     Columnas del pie
     El plegado lo hace <details> por su cuenta. Esto solo las abre
     todas en escritorio, donde no deben verse plegadas.
     --------------------------------------------------------------- */
  function initFooterGroups(root) {
    var grupos = root.querySelectorAll('[data-footer-group]');
    if (!grupos.length) return;

    var sync = function () {
      var escritorio = window.innerWidth >= 750;
      grupos.forEach(function (g) {
        if (escritorio) {
          g.open = true;
        } else if (!g.dataset.tocado) {
          g.open = false;
        }
      });
    };

    grupos.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (window.innerWidth < 750) g.dataset.tocado = '1';
      });
    });

    sync();
    window.addEventListener('resize', sync);
  }

  /* ---------------------------------------------------------------
     Apartados plegables en las páginas legales
     Unos términos de 1.700 palabras en un teléfono son un muro. Cada
     apartado numerado se convierte en un <details> nativo: así el
     buscador del navegador sigue encontrando el texto de dentro y el
     teclado funciona sin escribir nada extra. En escritorio se abren
     todos, igual que en las columnas del pie.
     --------------------------------------------------------------- */
  function initLegalSections(root) {
    // Las cinco políticas de Shopify traen este contenedor. La de cookies
    // es una página del tema, así que va por ruta; si cambia el handle,
    // hay que actualizarlo aquí.
    var RUTAS_TEMA = ['/pages/cookies-policy'];

    var zonas = [];
    var politica = root.querySelector('.shopify-policy__body .rte');
    if (politica) zonas.push(politica);

    var ruta = window.location.pathname.replace(/\/+$/, '');
    if (RUTAS_TEMA.indexOf(ruta) > -1) {
      var primerTitulo = root.querySelector('main h2');
      if (primerTitulo && primerTitulo.parentElement) zonas.push(primerTitulo.parentElement);
    }

    var plegables = [];
    zonas.forEach(function (zona) {
      plegables = plegables.concat(plegarApartados(zona));
    });
    if (!plegables.length) return;

    var sync = function () {
      var escritorio = window.innerWidth >= 750;
      plegables.forEach(function (d, i) {
        if (escritorio) {
          d.open = true;
        } else if (!d.dataset.tocado) {
          d.open = i === 0;
        }
      });
    };

    plegables.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (window.innerWidth < 750) d.dataset.tocado = '1';
      });
    });

    sync();
    window.addEventListener('resize', sync);
  }

  function plegarApartados(zona) {
    var hijos = Array.prototype.slice.call(zona.children);

    // El nivel de encabezado no es siempre el mismo: unas politicas usan
    // H2 para sus apartados y otras H3, con un H2 suelto de titulo. Se
    // elige el nivel que mas se repite, que es el de los apartados.
    var cuenta = { H2: 0, H3: 0 };
    hijos.forEach(function (el) {
      if (cuenta[el.tagName] !== undefined) cuenta[el.tagName]++;
    });
    var nivel = cuenta.H3 > cuenta.H2 ? 'H3' : 'H2';
    if (cuenta[nivel] < 3) return [];

    var grupos = [];
    var actual = null;

    hijos.forEach(function (el) {
      if (el.tagName === nivel) {
        actual = { titulo: el, cuerpo: [] };
        grupos.push(actual);
      } else if (actual) {
        actual.cuerpo.push(el);
      }
    });

    // Con dos apartados no se gana nada plegando, y se pierde al leer.
    if (grupos.length < 3) return [];

    return grupos.map(function (g) {
      var det = document.createElement('details');
      det.className = 'policy-acc';

      // El <details> ocupa el sitio del título antes de moverlo dentro
      zona.insertBefore(det, g.titulo);

      var sum = document.createElement('summary');
      sum.className = 'policy-acc__sum';
      sum.appendChild(g.titulo);

      var icono = document.createElement('span');
      icono.className = 'policy-acc__icon';
      icono.setAttribute('aria-hidden', 'true');
      sum.appendChild(icono);
      det.appendChild(sum);

      var caja = document.createElement('div');
      caja.className = 'policy-acc__body';
      g.cuerpo.forEach(function (n) { caja.appendChild(n); });
      det.appendChild(caja);

      return det;
    });
  }

  /* ---------------------------------------------------------------
     Carrusel de resultados
     La pista ya desliza sola con scroll-snap. Esto solo agrega las
     flechas y los puntos, y los esconde si todo cabe sin desplazar.
     --------------------------------------------------------------- */
  function initProof(root) {
    root.querySelectorAll('[data-proof]').forEach(function (section) {
      var track = section.querySelector('[data-proof-track]');
      var nav = section.querySelector('[data-proof-nav]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-proof-slide]'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-proof-dot]'));
      var prev = section.querySelector('[data-proof-prev]');
      var next = section.querySelector('[data-proof-next]');
      if (!slides.length) return;

      var index = 0;
      var frame = null;

      var scrollable = function () {
        return track.scrollWidth - track.clientWidth > 2;
      };

      var closest = function () {
        var left = track.scrollLeft;
        var best = 0;
        var min = Infinity;
        slides.forEach(function (slide, i) {
          var d = Math.abs(slide.offsetLeft - track.offsetLeft - left);
          if (d < min) { min = d; best = i; }
        });
        return best;
      };

      var sync = function () {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };

      var goTo = function (i) {
        var n = Math.max(0, Math.min(slides.length - 1, i));
        var target = slides[n];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft });
        index = n;
        sync();
      };

      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          index = closest();
          sync();
        });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });

      var layout = function () {
        if (nav) nav.hidden = !scrollable();
        index = closest();
        sync();
      };

      layout();
      window.addEventListener('resize', layout);
    });
  }

  /* ---------------------------------------------------------------
     Marquesinas
     El CSS traslada la pista un grupo entero. Para que no se vea un hueco,
     hacen falta suficientes copias como para llenar el ancho visible.
     --------------------------------------------------------------- */
  function initTickers(root) {
    root.querySelectorAll('[data-ticker]').forEach(function (ticker) {
      var track = ticker.querySelector('.ticker__track');
      if (!track) return;

      var original = track.querySelector('.ticker__group');
      if (!original) return;

      var template = original.cloneNode(true);

      var layout = function () {
        var animated =
          ticker.classList.contains('ticker--always') ||
          (ticker.classList.contains('ticker--mobile') && window.innerWidth < 750);

        // Volver a una sola copia antes de medir
        track.querySelectorAll('.ticker__group').forEach(function (g, i) {
          if (i > 0) g.remove();
        });
        track.style.removeProperty('--ticker-shift');
        track.style.removeProperty('--ticker-gap');

        if (!animated) return;

        var group = track.querySelector('.ticker__group');
        var groupWidth = group.scrollWidth;
        if (!groupWidth) return;

        /* Si un grupo no llena el ancho visible, se ve la copia siguiente y
           parece que el contenido se repite. Se reparte el sobrante entre los
           huecos para que un grupo ocupe al menos todo el ancho. */
        var container = ticker.clientWidth;
        if (groupWidth < container) {
          var count = group.children.length;
          if (count > 0) {
            var baseGap = parseFloat(getComputedStyle(group).columnGap) || 0;
            var extra = (container - groupWidth) / count;
            track.style.setProperty('--ticker-gap', baseGap + extra + 'px');
            groupWidth = group.scrollWidth;
          }
        }

        var needed = Math.ceil(container / groupWidth) + 1;
        if (needed < 2) needed = 2;

        for (var i = 1; i < needed; i++) {
          var copy = template.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          track.appendChild(copy);
        }

        track.style.setProperty('--ticker-shift', groupWidth + 'px');
      };

      layout();

      var pending;
      window.addEventListener('resize', function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(layout, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(layout);
      }
    });
  }

  /* ---------------------------------------------------------------
     Alto real de la cabecera fija
     Sin esto la barra de filtros se queda debajo del header al fijarse.
     --------------------------------------------------------------- */
  function trackHeaderHeight() {
    var header = document.querySelector('.header--sticky');
    if (!header) {
      document.documentElement.style.setProperty('--header-height', '0px');
      return;
    }

    var update = function () {
      document.documentElement.style.setProperty(
        '--header-height',
        Math.round(header.getBoundingClientRect().height) + 'px'
      );
    };

    update();
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(header);
    }
  }

  /* ---------------------------------------------------------------
     Pop-up de descuento
     --------------------------------------------------------------- */
  function initPopup(root) {
    root.querySelectorAll('[data-popup]').forEach(function (popup) {
      if (popup.dataset.bound === 'true') return;
      popup.dataset.bound = 'true';

      var key = popup.getAttribute('data-key');
      var frequency = popup.getAttribute('data-frequency');
      var days = parseInt(popup.getAttribute('data-days'), 10) || 7;
      var isOpen = false;
      var lastFocused = null;

      function alreadySeen() {
        if (frequency === 'always') return false;
        try {
          if (frequency === 'session') return sessionStorage.getItem(key) === '1';
          var stamp = parseInt(localStorage.getItem(key), 10);
          if (!stamp) return false;
          return Date.now() - stamp < days * 86400000;
        } catch (e) {
          return false;
        }
      }

      function remember() {
        if (frequency === 'always') return;
        try {
          if (frequency === 'session') sessionStorage.setItem(key, '1');
          else localStorage.setItem(key, String(Date.now()));
        } catch (e) {}
      }

      function open() {
        if (isOpen) return;
        isOpen = true;
        lastFocused = document.activeElement;
        popup.hidden = false;
        // Forzar un reflow para que la transición de entrada se aplique
        void popup.offsetWidth;
        popup.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        var target = popup.querySelector('input, button, a');
        if (target) target.focus({ preventScroll: true });
      }

      function close(persist) {
        if (!isOpen) return;
        isOpen = false;
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
        if (persist !== false) remember();

        window.setTimeout(function () {
          if (!isOpen) popup.hidden = true;
        }, 300);

        if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
      }

      popup.querySelectorAll('[data-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { close(true); });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen) close(true);
      });

      /* Mantener el foco dentro del diálogo mientras está abierto */
      popup.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !isOpen) return;
        var focusables = popup.querySelectorAll('a[href], button:not([disabled]), input, textarea, select');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      var copy = popup.querySelector('[data-popup-copy]');
      if (copy) {
        copy.addEventListener('click', function () {
          var code = popup.querySelector('[data-popup-code]');
          if (!code) return;
          var text = code.textContent.trim();

          var done = function () {
            copy.textContent = copy.getAttribute('data-copied');
            window.setTimeout(function () {
              copy.textContent = copy.getAttribute('data-label');
            }, 1800);
          };

          var fallback = function () {
            var helper = document.createElement('textarea');
            helper.value = text;
            helper.setAttribute('readonly', '');
            helper.style.position = 'fixed';
            helper.style.opacity = '0';
            document.body.appendChild(helper);
            helper.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            helper.remove();
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done, fallback);
          } else {
            fallback();
          }
        });
      }

      /* En el personalizador se abre al seleccionar la sección, sin recordar el cierre */
      if (window.Shopify && window.Shopify.designMode) {
        var sectionEl = popup.closest('.shopify-section') || popup;
        document.addEventListener('shopify:section:select', function (event) {
          if (event.target.contains(popup)) open();
        });
        document.addEventListener('shopify:section:deselect', function (event) {
          if (event.target.contains(popup)) close(false);
        });
        if (sectionEl) return;
      }

      /* El formulario de Shopify recarga la página al enviarse. Si volvemos
         con el mensaje de éxito, se reabre de inmediato para enseñar el
         código, sin respetar el "ya lo vio": es justo lo que vino a buscar. */
      if (popup.querySelector('.form-status--success')) {
        open();
        return;
      }

      if (alreadySeen()) return;

      var trigger = popup.getAttribute('data-trigger');

      if (trigger === 'scroll') {
        var percent = parseInt(popup.getAttribute('data-scroll'), 10) || 35;
        var onScroll = function () {
          var scrollable = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollable <= 0) return;
          if ((window.scrollY / scrollable) * 100 >= percent) {
            open();
            window.removeEventListener('scroll', onScroll);
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else if (trigger === 'exit') {
        var onLeave = function (event) {
          if (event.clientY <= 0) {
            open();
            document.removeEventListener('mouseout', onLeave);
          }
        };
        document.addEventListener('mouseout', onLeave);
        /* En móvil no hay puntero: se cae a un retraso largo */
        window.setTimeout(function () { open(); }, 20000);
      } else {
        window.setTimeout(open, parseInt(popup.getAttribute('data-delay'), 10) || 0);
      }
    });
  }

  /* ---------------------------------------------------------------
     Animación al entrar en pantalla
     --------------------------------------------------------------- */
  function initReveal(root) {
    var targets = root.querySelectorAll('.reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

    targets.forEach(function (t) { observer.observe(t); });
  }

  /* ---------------------------------------------------------------
     Arranque
     --------------------------------------------------------------- */
  function init(root) {
    initAnnouncement(root);
    initHeader(root);
    initAccordions(root);
    initFaqTabs(root);
    initGallery(root);
    initQuantity(root);
    initCart(root);
    initVariants(root);
    initQuiz(root);
    initPopup(root);
    initReveal(root);
    initTickers(root);
    initProof(root);
    initQuickView(root);
    initFooterGroups(root);
    initLegalSections(root);
    initBackgroundVideo(root);
    trackHeaderHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-inicializar secciones al editarlas en el personalizador */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
